import { Component, effect, OnInit } from '@angular/core';
import { IonicModule, ModalController } from '@ionic/angular';
import { UnitsHelper } from 'app/services/units.helper';
import { Volume } from 'convert';
import { ICan } from 'app/models/can';

import { Store } from '@ngrx/store';
import { FormBuilder, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';

import * as fromBar from 'app/state/bar';
import * as fromBeverage from 'app/state/beverage';
import * as fromCan from 'app/state/can';
import { CanService } from 'app/services/dal/can.service';
@Component({
  selector: 'app-new-can',
  templateUrl: './new-can.component.html',
  styleUrls: ['./new-can.component.scss'],
  standalone: true,
  imports: [IonicModule, FormsModule, ReactiveFormsModule]
})
export class NewCanComponent implements OnInit {

  item!: ICan | undefined;
  barId = this.store.selectSignal(fromBar.selectBarId)
  beverageId = this.store.selectSignal(fromBeverage.selectCurrentId);

  ean = this.store.selectSignal(fromCan.selectEan);

  cans: ICan[] = [];
  unitType!: Volume;

  form = this.fb.group({
    count: ['', { validators: [Validators.required] }],
    location: ['',],
    selectCan: ['']
  });

  constructor(
    private store: Store,
    private modalController: ModalController,
    public unitHelper: UnitsHelper,
    private fb: FormBuilder,
    private canService: CanService
  ) { }

  ngOnInit() {
    this.populateAvailableCans();
  }

  selectItem(event: any) {
    const item = event.detail.value as ICan;
    item.barId = this.barId() ?? '';
    item.beverageId;

    this.dismiss(item);
  }

  closeModal() {
    this.modalController.dismiss({
      dismissed: true
    }, 'cancel');
  }

  dismiss(item: ICan) {

    const id = this.canService.getNewId();
    this.store.dispatch(fromCan.setItem({ id }));
    this.store.dispatch(fromCan.addItem({ id, item }));

    this.modalController.dismiss({
      id: id
    }, 'open-edit');
  }



  private populateAvailableCans() {
    this.cans = [];
    var volume = this.unitHelper.getUnit(this.unitType);
    if (volume.system === "imperial") {
      this.cans.push(
        { beverageId: this.beverageId() ?? '', barId: this.barId() ?? '', bestBeforeDate: null, filledDate: null, notificationDate: null, size: 354, type: "imperial", name: "12oz", count: 1 },
        { beverageId: this.beverageId() ?? '', barId: this.barId() ?? '', bestBeforeDate: null, filledDate: null, notificationDate: null, size: 651, type: "imperial", name: "22oz", count: 1 },
        { beverageId: this.beverageId() ?? '', barId: this.barId() ?? '', bestBeforeDate: null, filledDate: null, notificationDate: null, size: 1892, type: "imperial", name: "64oz", count: 1 }
      );
    } else {
      this.cans.push(
        { beverageId: this.beverageId() ?? '', barId: this.barId() ?? '', bestBeforeDate: null, filledDate: null, notificationDate: null, size: 500, type: "metric", name: "0.50l", count: 1 },
        { beverageId: this.beverageId() ?? '', barId: this.barId() ?? '', bestBeforeDate: null, filledDate: null, notificationDate: null, size: 440, type: "metric", name: "0.44l", count: 1 },
        { beverageId: this.beverageId() ?? '', barId: this.barId() ?? '', bestBeforeDate: null, filledDate: null, notificationDate: null, size: 330, type: "metric", name: "0.33l", count: 1 },
        { beverageId: this.beverageId() ?? '', barId: this.barId() ?? '', bestBeforeDate: null, filledDate: null, notificationDate: null, size: 250, type: "metric", name: "0.25l", count: 1 }
      );
    }
  }


}
